import { render, staticRenderFns } from "./WheelBattleBasicInfoForm.vue?vue&type=template&id=36f08428&scoped=true&"
import script from "./WheelBattleBasicInfoForm.vue?vue&type=script&lang=js&"
export * from "./WheelBattleBasicInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./WheelBattleBasicInfoForm.vue?vue&type=style&index=0&id=36f08428&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f08428",
  null
  
)

export default component.exports